module.exports = __webpack_public_path__ + "img/nj.5e72aa2e.png";